import { render, staticRenderFns } from "./mbsut.vue?vue&type=template&id=32c293f8&"
import script from "./mbsut.vue?vue&type=script&lang=js&"
export * from "./mbsut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports